import { Globals } from "../Utils/Globals.js";
export var Cursors;
(function (Cursors) {
    Cursors["auto"] = "auto";
    Cursors["default"] = "default";
    Cursors["none"] = "none";
    Cursors["context-menu"] = "context-menu";
    Cursors["help"] = "help";
    Cursors["pointer"] = "pointer";
    Cursors["progress"] = "progress";
    Cursors["wait"] = "wait";
    Cursors["cell"] = "cell";
    Cursors["crosshair"] = "crosshair";
    Cursors["text"] = "text";
    Cursors["vertical-text"] = "vertical-text";
    Cursors["alias"] = "alias";
    Cursors["copy"] = "copy";
    Cursors["move"] = "move";
    Cursors["no-drop"] = "no-drop";
    Cursors["not-allowed"] = "not-allowed";
    Cursors["e-resize"] = "e-resize";
    Cursors["n-resize"] = "n-resize";
    Cursors["ne-resize"] = "ne-resize";
    Cursors["nw-resize"] = "nw-resize";
    Cursors["s-resize"] = "s-resize";
    Cursors["se-resize"] = "se-resize";
    Cursors["sw-resize"] = "sw-resize";
    Cursors["w-resize"] = "w-resize";
    Cursors["ew-resize"] = "ew-resize";
    Cursors["ns-resize"] = "ns-resize";
    Cursors["nesw-resize"] = "nesw-resize";
    Cursors["nwse-resize"] = "nwse-resize";
    Cursors["col-resize"] = "col-resize";
    Cursors["row-resize"] = "row-resize";
    Cursors["all-scroll"] = "all-scroll";
    Cursors["zoom-in"] = "zoom-in";
    Cursors["zoom-out"] = "zoom-out";
    Cursors["grab"] = "grab";
    Cursors["grabbing"] = "grabbing";
})(Cursors || (Cursors = {}));
export class CursorHandler {
    _cursorEnabled;
    _cursor; //todo add change cursor on blur
    _parent;
    constructor(parent, cursorEnabled) {
        this._cursorEnabled = cursorEnabled;
        this._parent = parent;
    }
    updateCursorToDefault() {
        Globals.canvasContainer.style.cursor = Cursors.default;
    }
    update(objectDragging, objIntercepted) {
        if (this._cursorEnabled) { //todo add general cursor
            let cursor;
            if (objectDragging) {
                cursor = objectDragging.cursorOnDrag || Cursors.grabbing;
            }
            else if (objIntercepted) {
                const obj = objIntercepted.object;
                cursor = obj.cursorOnHover || (obj.isDraggable && this._parent.dragAndDropEnabled && this._parent.dragAndDropViewportCheck ? (obj.areAllParentsEnabled ? Cursors.grab : Cursors["not-allowed"]) : Cursors.default);
            }
            else {
                cursor = Cursors.default;
            }
            if (cursor !== this._cursor) {
                this._cursor = cursor;
                if (Cursors[cursor]) {
                    Globals.canvasContainer.style.cursor = cursor;
                }
                else {
                    Globals.canvasContainer.style.cursor = `url(${cursor}), default`;
                }
            }
        }
    }
}
//# sourceMappingURL=CursorHandler.js.map